'use client';

import Image from 'next/image';
import Balancer from 'react-wrap-balancer';

import SupportEmailLink from '@/components/SupportEmailLink';
import SupportTwitterLink from '@/components/SupportTwitterLink';

export default function FounderMessage({ className, sessionData }) {
  return (
    <div className={className}>
      <h2 className="text-center text-2xl font-extrabold leading-none tracking-tight dark:text-white md:text-3xl xl:text-4xl">
        <Balancer>
          I can&apos;t wait to see{' '}
          <span className="bg-gradient-to-r from-[#b92b27] to-[#1565c0] bg-clip-text text-transparent">
            your stories
          </span>
        </Balancer>
      </h2>

      <div className="mt-4 flex flex-col items-center gap-8 sm:flex-row">
        <figure className="">
          <Image
            width={200}
            height={200}
            className="rounded-full"
            src="/Me.jpeg"
            alt="The founder's profile picture"
          />
        </figure>

        <div className="max-w-prose">
          <p className="mt-4">
            👋 Hi. My name is Murilo and <b>I build contextualize.ai</b>.
          </p>

          <p className="mt-4">
            It&apos;s been 10 years since I built my first data visualization,
            and 15 years since I started writing software. I&apos;m putting a
            lot of effort into contextualize.ai so that you can benefit from my
            learnings and experience.
          </p>

          <p className="mt-4">
            Communicating effectively through data visualizations is hard, and I
            want to empower you with tools to <b>tell your own great stories</b>
            , with data.
          </p>

          <p className="mt-4">
            If you need anything just send me an email at{' '}
            <SupportEmailLink sessionOrSessionData={sessionData} /> or reach out
            on Twitter at{' '}
            <SupportTwitterLink sessionOrSessionData={sessionData} />.
          </p>
        </div>
      </div>
    </div>
  );
}
